import { render, staticRenderFns } from "./DashboardServicios.vue?vue&type=template&id=a8244338&scoped=true&"
import script from "./DashboardServicios.vue?vue&type=script&lang=js&"
export * from "./DashboardServicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8244338",
  null
  
)

export default component.exports